import React from 'react';
import { ArrowUp, ArrowDown, Trash2, Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

const slug = (t) => t.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40);

export const CamposPersonalizadosEditor = ({ campos, onChange }) => {
  const set = (i, patch) => onChange(campos.map((c, j) => (j === i ? { ...c, ...patch } : c)));
  const mover = (i, d) => {
    const n = [...campos];
    [n[i], n[i + d]] = [n[i + d], n[i]];
    onChange(n);
  };
  const agregar = () => onChange([...campos, { key: '', label: '', tipo: 'texto', requerido: false, _autoKey: true }]);

  return (
    <div className="space-y-2" data-testid="campos-personalizados-editor">
      <div className="flex items-center justify-between">
        <Label>Campos personalizados</Label>
        <Button type="button" size="sm" variant="outline" onClick={agregar} data-testid="campo-agregar-btn">
          <Plus className="w-3.5 h-3.5 mr-1" /> Agregar campo
        </Button>
      </div>
      {campos.length === 0 && <p className="text-xs text-gray-500">Sin campos adicionales.</p>}
      {campos.map((c, i) => (
        <div key={i} className="flex flex-wrap items-center gap-2 p-2 border rounded-lg bg-gray-50" data-testid={`campo-row-${i}`}>
          <Input className="flex-1 min-w-[140px] h-8" placeholder="Nombre visible (ej. Nº de expediente)" value={c.label}
            data-testid={`campo-label-${i}`}
            onChange={(e) => set(i, { label: e.target.value, ...(c._autoKey ? { key: slug(e.target.value) } : {}) })} />
          <Input className="w-36 h-8 font-mono text-xs" placeholder="identificador" value={c.key}
            data-testid={`campo-key-${i}`}
            onChange={(e) => set(i, { key: slug(e.target.value), _autoKey: false })} />
          <select className="h-8 border rounded-md px-2 text-sm bg-white" value={c.tipo} data-testid={`campo-tipo-${i}`}
            onChange={(e) => set(i, { tipo: e.target.value })}>
            <option value="texto">Texto</option>
            <option value="numero">Número</option>
          </select>
          <label className="flex items-center gap-1 text-xs">
            <input type="checkbox" checked={c.requerido} data-testid={`campo-requerido-${i}`}
              onChange={(e) => set(i, { requerido: e.target.checked })} /> Obligatorio
          </label>
          <div className="flex gap-0.5">
            <Button type="button" size="icon" variant="ghost" className="h-7 w-7" disabled={i === 0} onClick={() => mover(i, -1)} data-testid={`campo-subir-${i}`}><ArrowUp className="w-3.5 h-3.5" /></Button>
            <Button type="button" size="icon" variant="ghost" className="h-7 w-7" disabled={i === campos.length - 1} onClick={() => mover(i, 1)} data-testid={`campo-bajar-${i}`}><ArrowDown className="w-3.5 h-3.5" /></Button>
            <Button type="button" size="icon" variant="ghost" className="h-7 w-7 text-red-600" onClick={() => onChange(campos.filter((_, j) => j !== i))} data-testid={`campo-eliminar-${i}`}><Trash2 className="w-3.5 h-3.5" /></Button>
          </div>
          {c.key && <code className="basis-full text-[11px] text-violet-700">{`<<${c.key}>>`}</code>}
        </div>
      ))}
    </div>
  );
};

export const CamposPersonalizadosInputs = ({ campos, valores, onChange }) => {
  if (!campos?.length) return null;
  return (
    <div className="space-y-3 p-3 border rounded-lg bg-violet-50/40" data-testid="campos-personalizados-inputs">
      {campos.map((c) => (
        <div key={c.key}>
          <Label>{c.label}{c.requerido ? ' *' : ''}</Label>
          <Input type={c.tipo === 'numero' ? 'number' : 'text'} value={valores?.[c.key] || ''}
            data-testid={`campo-valor-${c.key}`}
            onChange={(e) => onChange({ ...(valores || {}), [c.key]: e.target.value })} />
        </div>
      ))}
    </div>
  );
};

export const limpiarCampos = (campos) => campos.map(({ key, label, tipo, requerido }) => ({ key, label: label.trim(), tipo, requerido }));
